import axios from 'axios'

const settings = window.wisenetwork || {}

export default {
    /**
     * By default returns only the user's player information
     * 
     * parameters: memberno, clubid, name(?)
     * 
     * @param {Object} params
     * @returns {Promise}
     */
    getPlayers(params = {}) {
        let queryString = '';
        
        if (Object.keys(params).length > 0) {
            queryString = '?'+settings.param(params);
        }
        
        return axios({
            url: `${ settings.REST_URL }/golf/player/${ queryString }`,
            method: 'GET',
            withCredentials: true,
        })
    },
    
    /**
     * 
     * @param {Object} params
     * @returns {Promise}
     */
    getClubs(params = {}) {
        let queryString = '';
        
        if (Object.keys(params).length > 0) {
            queryString = '?'+settings.param(params);
        }
        
        return axios({
            url: `${ settings.REST_URL }/golf/club/${ queryString }`,
            method: 'GET',
            withCredentials: true,
        })
    },

    /**
     * 
     * @param {Object} data 
     * @returns 
     */
    saveVisitorPlayer(data) {
        let queryString = '';
        
        if (typeof window.product !== 'undefined') {
            const { productId } = window.product;

            queryString = '?'+settings.param({ productid: productId });
        }

        return axios({
            url: `${ settings.REST_URL }/golf/visitorplayer/${ queryString }`,
            method: 'POST',
            withCredentials: true,
            data
        })
    },
}